import { render, staticRenderFns } from "./returnable-orders.vue?vue&type=template&id=1da5b50c&"
import script from "./returnable-orders.vue?vue&type=script&lang=js&"
export * from "./returnable-orders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports